import { render, staticRenderFns } from "./CardSidebar.vue?vue&type=template&id=403cf112"
import script from "./CardSidebar.vue?vue&type=script&lang=js"
export * from "./CardSidebar.vue?vue&type=script&lang=js"
import style0 from "./CardSidebar.vue?vue&type=style&index=0&id=403cf112&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports